module.exports = __webpack_public_path__ + "images/a-kurdyukov-6ec4fd.jpg";